import type { SessionUser } from '@afra/shared'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useNavigate } from 'react-router-dom'
import { api } from '../../lib/api'

/**
 * The one thing that must never be subtle.
 *
 * Every other screen deliberately looks exactly as it does for the charity —
 * that is the point of impersonation and also its danger. This bar sits above
 * the masthead, in the warning colour, and says whose account is on screen.
 */
export function ImpersonationBar({ user }: { user: SessionUser }) {
  const queryClient = useQueryClient()
  const navigate = useNavigate()

  const leave = useMutation({
    mutationFn: api.endImpersonation,
    onSuccess: () => {
      // None of the cache belongs to the account we are returning to.
      queryClient.clear()
      navigate('/platform')
    },
  })

  if (!user.impersonating) return null

  return (
    <div className="impersonation-bar">
      <div className="impersonation-bar__inner">
        <span>
          شما به‌جای <strong>{user.impersonating.orgName}</strong> وارد شده‌اید. هر کاری بکنید به
          نام همین مؤسسه ثبت می‌شود و نام شما هم کنارش می‌ماند.
        </span>
        <button
          type="button"
          className="btn btn--quiet btn--sm"
          disabled={leave.isPending}
          onClick={() => leave.mutate()}
        >
          {leave.isPending ? 'در حال بازگشت…' : 'بازگشت به حساب خودم'}
        </button>
      </div>
    </div>
  )
}
